<template>
  <div class="lavendla-rating">
    <review-stars class="lavendla-rating__stars" :rating="numericRating" />
    <span
      v-if="showRatingText"
      class="lavendla-rating__rating-text"
      v-text="ratingText"
    />
    <span
      v-if="numberOfReviews"
      class="lavendla-rating__number-of-reviews"
      aria-hidden="true"
      >•</span
    >
    <span
      :is="link !== '' ? 'a' : 'span'"
      v-if="numberOfReviews"
      :href="link || null"
      class="lavendla-rating__number-of-reviews"
    >
      {{ numberOfReviewsText }}
    </span>
  </div>
</template>

<script lang="ts">
import ReviewStars from 'Main/reviews/components/ReviewStars.vue';

export default {
  name: 'RatingStars',

  components: {
    ReviewStars,
  },

  props: {
    rating: {
      required: true,
      type: [Number, String],
    },
    numberOfReviews: {
      type: [Number, String],
      default: null,
    },
    showRatingText: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      texts: theme_vars.counselorSlider,
    };
  },

  computed: {
    numericRating() {
      const value = Number.parseFloat(this.rating as string);
      if (!Number.isFinite(value)) {
        return 0;
      }
      return Math.max(0, Math.min(5, value));
    },

    numberOfReviewsText() {
      return this.numberOfReviews
        ? `${this.numberOfReviews} ${this.texts.ratings}`
        : '';
    },

    ratingText() {
      return Math.round(this.numericRating * 10) / 10;
    },
  },
};
</script>
